import { type PayloadAction, createSlice } from "@reduxjs/toolkit";

import type { RootState } from "./index";

import themeConfig from "~/config/theme-config";

export interface InitialState {
  darkMode: boolean;
  isCollapsed: boolean;
  mobileMenu: boolean;
}

const initialState: InitialState = {
  darkMode: themeConfig.layout.darkMode,
  isCollapsed: themeConfig.layout.menu.isHidden,
  mobileMenu: themeConfig.layout.mobileMenu,
};

export const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    // handle dark mode
    handleDarkMode: (state: RootState, action: PayloadAction<boolean>) => {
      state.darkMode = action.payload;
    },
    // handle sidebar collapsed
    handleSidebarCollapsed: (state: RootState, action: PayloadAction<boolean>) => {
      state.isCollapsed = action.payload;
    },
    handleMobileMenu: (state, action) => {
      state.mobileMenu = action.payload;
    },
  },
});

export const { handleDarkMode, handleSidebarCollapsed, handleMobileMenu } = layoutSlice.actions;

export default layoutSlice.reducer;
